import { WeddingIcon } from "@porchpass/ui";
import {
  FormTable,
  FormTableBody,
  MaritalStatusFields,
  type MaritalStatusFormData,
} from "@porchpass/ui";
import * as React from "react";
import { useApplicationFormStore } from "../hooks/useApplicationFormStore";
import { validateDependentsAges } from "../utils/validationSchemas";

interface MaritalStatusFormProps {
  isCoBorrower?: boolean;
}

export const MaritalStatusForm: React.FC<MaritalStatusFormProps> = ({
  isCoBorrower = false,
}) => {
  const store = useApplicationFormStore();
  const borrower = isCoBorrower
    ? store.data.coBorrower
    : store.data.primaryBorrower;
  const updateBorrower = isCoBorrower
    ? store.updateCoBorrower
    : store.updatePrimaryBorrower;

  const borrowerPrefix = isCoBorrower ? "coBorrower" : "primaryBorrower";
  const dependentsError =
    store.fieldErrors[`${borrowerPrefix}.dependentsAgesYears`];

  if (!borrower) return null;

  const handleBorrowerChange = (patch: Partial<MaritalStatusFormData>) => {
    if ("dependentsAgesYears" in patch) {
      const parsed = patch.dependentsAgesYears;
      if (dependentsError && !validateDependentsAges(parsed)) {
        store.clearFieldError(`${borrowerPrefix}.dependentsAgesYears`);
      }
      if (parsed?.length === 0) {
        store.clearFieldError(`${borrowerPrefix}.dependentsAgesYears`);
      }
    }
    updateBorrower(patch);
  };

  return (
    <FormTable
      title="Marital Status"
      headerIcon={
        <WeddingIcon
          variant="bulk-rounded"
          size={16}
          className="text-primary"
        />
      }
    >
      <FormTableBody>
        <MaritalStatusFields
          value={{
            maritalStatus: borrower.maritalStatus,
            dependentsAgesYears: borrower.dependentsAgesYears,
          }}
          onChange={handleBorrowerChange}
          errors={{
            maritalStatus: store.fieldErrors[`${borrowerPrefix}.maritalStatus`],
            dependentsAgesYears:
              store.fieldErrors[`${borrowerPrefix}.dependentsAgesYears`],
          }}
          onMaritalStatusChange={() => {
            if (store.fieldErrors[`${borrowerPrefix}.maritalStatus`]) {
              store.clearFieldError(`${borrowerPrefix}.maritalStatus`);
            }
          }}
        />
      </FormTableBody>
    </FormTable>
  );
};

export default MaritalStatusForm;
